module.exports = __webpack_public_path__ + "static/media/icon_duplicate-data.f59e2b57.svg";